export default __webpack_public_path__ + "static/media/adventure.04dac105.png";